const PatientRace = {
    ASIAN: "Asian",
    BLACK: "Black",
    AMERICAN_INDIAN_OR_ALASKA_NATIVE: "American Indian or Alaska Native",
    NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER: "Native Hawaiian or Pacific Islander",
    MIDDLE_EASTERN_OR_NORTH_AFRICAN: "Middle Eastern or North African",
    OTHER: "Other",
    TWO_OR_MORE_RACES: "Two or More Races",
    UNKNOWN: "Unknown",
    WHITE: "White"
};

export default PatientRace;